import React from 'react';
import { withAuthorization } from '../Session';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import { dateFormatUtil } from '../Utilities';

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Alert from 'react-bootstrap/Alert';
import './styles.css';
import Spinner from 'react-bootstrap/Spinner';
import RestServices from '../services/RestServices.js';

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

import Modal from 'react-bootstrap/Modal';

class GCPurchase extends React.Component {
    _isMounted = false;
    state = {
        search_key: '',
        search_by: 'ProfileUniqeID',

        isLoading: false,
        isLoaded: false,
        btnClicked: false,
        isProcessing: false,
        showLoading: true,
        allUsers: [this.props.user],
        selectedUser: [],
        productDetail: [],
        showStep: 1,
        denomination: 0,
        discount: 0,
        quantity: 1,
        comment: '',

        alertMessage: '',
        alert: 0,
        currentTotalBalance: 0,
        qtyOptions: [1, 2, 3, 4],
        MasterGiftCard: this.props.GCard ? this.props.GCard.MasterGiftCard : '',
        GCApiRoot: ''
    };

    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this.setState({
            discount: this.props.GCard.offer ? this.props.GCard.offer : 0,
            productDetail: this.props.GCard,
            denomination: this.props.GCard.price
                ? this.props.GCard.price.min
                    ? this.props.GCard.price.min
                    : 0
                : 0
        });

        let selectedUser = [];
        selectedUser['ProfileUniqeID'] = this.props.user.ProfileUniqeID;
        selectedUser['FullName'] = this.props.user.FullName;
        this.setState({ selectedUser: selectedUser });
        this._isMounted = true;
        setTimeout(() => {
            this.getProfileBalance();
        }, 1000);
    }

    async onSelect(UserName) {
        let UserNameNew = UserName.substring(
            UserName.indexOf('(') + 1,
            UserName.lastIndexOf(')')
        );
        let selectedUser = [];
        this.state.allUsers.forEach((user) => {
            if (user.ProfileUniqeID === UserNameNew) {
                selectedUser = user;
            }
        });

        if (selectedUser) {
            this.setState({
                selectedUser: selectedUser,
                currentTotalBalance: selectedUser.walletbalance
            });
        }
    }
    async searchUsers(searchKey) {
        if (this._isMounted) {
            this.setState({ search_key: searchKey });
        }
        let bodyData = {
            search_key: searchKey.toUpperCase(),
            search_by: this.state.search_by
        };
        await RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodyData,
            'profiles/getAllUsers'
        )
            .then((response) => response.json())
            .then((responseData) => {
                if (this._isMounted && responseData.list) {
                    this.setState({ allUsers: responseData.list });
                }
            });
    }

    async getProfileBalance() {
        let dataRow = {
            UniqeID: this.props.user.ProfileUniqeID,
            UserRole: 'StoreCP' //this.props.role
        };
        await RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            dataRow,
            'profiles/getProfileBalance'
        )
            .then((response) => response.json())
            .then((responseData) => {
                if (this._isMounted) {
                    this.setState({
                        showLoading: false,
                        btnClicked: false,
                        isProcessing: false,
                        currentTotalBalance: responseData.walletbalance
                            ? responseData.walletbalance
                            : 0
                    });
                }
            });
    }

    capitalizeFirstLetter(string) {
        if (string) {
            const words = string.split(' ');

            for (let i = 0; i < words.length; i++) {
                words[i] = words[i][0].toUpperCase() + words[i].substr(1);
            }

            return words.join(' ');
        } else {
            return string;
        }
    }

    onChangeValues = (event) => {
        if (event.target.value === '')
            this.setState({ [event.target.name]: '' });
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };
    makeRandomId(length) {
        var result = '';
        var characters =
            'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(
                Math.floor(Math.random() * charactersLength)
            );
        }
        return result;
    }

    getGiftCard = () => {
        if (this.state.isProcessing) {
            alert('Please wait...');
        } else {
            if (this._isMounted) {
                this.setState({
                    isProcessing: true,
                    showLoading: true,
                    modalShow: false
                });
            }
            if (
                parseFloat(this.state.currentTotalBalance) >=
                parseFloat(this.state.denomination * this.state.quantity)
            ) {
                let refno = 'IB-' + this.makeRandomId(10);
                let bodydata = {
                    firstname: this.state.selectedUser.FullName
                        ? this.state.selectedUser.FullName
                        : this.props.user.FullName,
                    email: this.state.selectedUser.EmailId
                        ? this.state.selectedUser.EmailId
                        : this.props.user.EmailId,
                    PinCode: this.state.selectedUser.PinCode
                        ? this.state.selectedUser.PinCode
                        : this.props.user.PinCode,
                    telephone: this.state.selectedUser.PhoneNumber
                        ? this.state.selectedUser.PhoneNumber
                        : this.props.user.PhoneNumber,
                    amount: parseFloat(
                        this.state.denomination * this.state.quantity
                    ),
                    sku: this.state.productDetail.sku,
                    productId: this.state.productDetail.productId,
                    syncOnly: this.state.quantity <= 4 ? true : false,
                    price: parseInt(this.state.denomination),
                    qty: this.state.quantity,
                    refno: refno,
                    MasterGiftCard: this.state.MasterGiftCard,
                    ProfileUniqeID: this.state.selectedUser.ProfileUniqeID
                        ? this.state.selectedUser.ProfileUniqeID
                        : this.props.user.ProfileUniqeID,
                    comment: this.state.comment,
                    IBMP: this.state.productDetail.IBMP
                        ? this.state.productDetail.IBMP
                        : 0,
                    discount: this.state.discount,
                    AddedTimeStamp: dateFormatUtil(),
                    UpdatedBy: this.props.user.ProfileUniqeID,
                    productName: this.state.productDetail.brandName
                        ? this.state.productDetail.brandName
                        : this.state.productDetail.name
                };
                try {
                    RestServices.GlobalPost(
                        localStorage.getItem('FirebaseToken'),
                        bodydata,
                        'gcpurchase/'+this.state.MasterGiftCard+'/PlaceOrder'
                    )
                    .then((response) => response.json())
                        .then((responseData) => {
                            
                            this.setState({
                                showLoading: false,
                                btnClicked: false,
                                isProcessing: false,
                                
                            });
                            
                            if (this._isMounted) {
                                    this.setState({
                                        showLoading: false,
                                        btnClicked: false,
                                        isProcessing: false,
                                        alert: responseData.error?1:2,
                                        alertMessage:responseData.error?responseData.error:responseData.message
                                    });
                            }
                            if(responseData.message){
                                this.getProfileBalance();
                            }
                        
                        })
                
                } catch (error) {
                    if (this._isMounted) {
                        this.setState({
                            showLoading: false,
                            btnClicked: false,
                            isProcessing: false,
                            alert: 1,
                            alertMessage: error.message
                        });
                    }
                }
            } else {
                if (this._isMounted) {
                    this.setState({
                        showLoading: false,
                        btnClicked: false,
                        isProcessing: false,
                        alert: 1,
                        alertMessage:
                            'Your balance amount ' +
                            this.state.currentTotalBalance +
                            ' is not enough balance to purchase this Gift Card.'
                    });
                }
            }
        }
    };
    onChangeValues = (event) => {
        if (event.target.value === '')
            this.setState({ [event.target.name]: '' });
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };

    handleChangeDenomination = (event) => {
        if (parseFloat(event.target.value) > 0) {
            this.setState({
                [event.target.name]: parseFloat(event.target.value)
            });
        } else {
            this.setState({ [event.target.name]: '' });
        }
    };

    handleChangeQuantity = (event) => {
        if (Number.isNaN(Number.parseFloat(event.target.value))) {
            var amountValue = 0;
        } else {
            var amountValue = parseFloat(event.target.value);
        }

        this.setState({ [event.target.name]: amountValue });
    };

    confirmSubmit = () => {
        if (this._isMounted) {
            this.setState({ btnClicked: true, modalShow: true });
        }
    };

    handleClose = () => {
        if (this._isMounted) {
            this.setState({ btnClicked: false, modalShow: false });
        }
    };

    render() {
        return (
            <Container>
                {this.state.showLoading && <Spinner animation="border" />}
                <Row
                    style={{
                        marginBottom: '1rem',
                        justifyContent: 'space-between',
                        display: 'flex',
                        flexDirection: 'row',
                        textAlign: 'left'
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            margin: '0.5rem'
                        }}
                    >
                        <p></p>
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            margin: '0.5rem'
                        }}
                    >
                        <p>
                            Wallet balance: ₹{' '}
                            {parseFloat(this.state.currentTotalBalance).toFixed(
                                2
                            )}
                        </p>
                    </div>
                </Row>

                {this.state.alert === 1 && (
                    <Row>
                        <Col>
                            <Alert variant="danger">
                                {this.state.alertMessage}
                            </Alert>
                        </Col>
                    </Row>
                )}

                {this.state.alert === 2 && (
                    <Row>
                        <Col>
                            <Alert variant="success">
                                {this.state.alertMessage}
                            </Alert>
                        </Col>
                    </Row>
                )}

                {this.state.productDetail.sku && (
                    <Row className="product_detail">
                        <Col xs={6}>
                            <h2>{this.state.productDetail.brandName}</h2>
                            <p>SKU: {this.state.productDetail.sku} </p>
                            {this.state.productDetail.offer > 0 && (
                                <p>{this.state.productDetail.offer}% OFF</p>
                            )}

                            <div className="product_thumbnail_section">
                                {this.state.productDetail.sku ===
                                    'EGCGBSRTPL001' ||
                                this.state.productDetail.sku ===
                                    'EGCGBAMZSVSRTP001' ? (
                                    <img
                                        className="product_thumbnail"
                                        src={
                                            this.state.productDetail.id + '.jpg'
                                        }
                                    />
                                ) : (
                                    <img
                                        className="product_thumbnail_auto"
                                        src={
                                            this.state.productDetail.images
                                                .mobile
                                        }
                                    />
                                )}
                            </div>
                            <p>
                                <span>
                                    Validity: {this.state.productDetail.expiry}
                                </span>
                            </p>
                        </Col>
                        <Col xs={6}>
                            {this.props.role === 'Admin' && (
                                <Row>
                                    <Form.Group as={Col}>
                                        <Form.Label>Select User</Form.Label>
                                        <Autocomplete
                                            name="search_key"
                                            value={
                                                this.state.selectedUser
                                                    .FullName +
                                                ' (' +
                                                this.state.selectedUser
                                                    .ProfileUniqeID +
                                                ')'
                                            }
                                            onInputChange={(
                                                event,
                                                newInputValue
                                            ) => {
                                                if (newInputValue.length > 1) {
                                                    this.searchUsers(
                                                        newInputValue
                                                    );
                                                }
                                            }}
                                            options={this.state.allUsers.map(
                                                (user) =>
                                                    user.FullName +
                                                    ' (' +
                                                    user.ProfileUniqeID +
                                                    ')'
                                            )}
                                            onChange={(event, newValue) => {
                                                if (newValue) {
                                                    this.onSelect(newValue);
                                                } else {
                                                }
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    margin="normal"
                                                    variant="outlined"
                                                />
                                            )}
                                        />
                                    </Form.Group>
                                </Row>
                            )}
                            {this.state.productDetail.price.type === 'SLAB' ? (
                                <Row>
                                    <Form.Group as={Col}>
                                        <Form.Label>
                                            Select denomination
                                        </Form.Label>
                                        <select
                                            className="form-control"
                                            style={{ width: '100%' }}
                                            name="denomination"
                                            onChange={
                                                this.handleChangeDenomination
                                            }
                                            value={this.state.denomination}
                                        >
                                            {this.state.productDetail.price.denominations.map(
                                                (denomination) => (
                                                    <option
                                                        key={denomination}
                                                        value={denomination}
                                                    >
                                                        {denomination}
                                                    </option>
                                                )
                                            )}
                                        </select>
                                    </Form.Group>
                                </Row>
                            ) : (
                                <Row>
                                    <Form.Group as={Col}>
                                        <Form.Label>
                                            Enter denomination
                                        </Form.Label>
                                        <Form.Control
                                            placeholder="Enter denomination"
                                            type="number"
                                            name="denomination"
                                            value={this.state.denomination}
                                            onChange={
                                                this.handleChangeDenomination
                                            }
                                        />
                                        <p className="denomination_min_max">
                                            Min:{' '}
                                            {
                                                this.state.productDetail.price
                                                    .currency.symbol
                                            }
                                            {this.state.productDetail.price.min}{' '}
                                            Max:{' '}
                                            {
                                                this.state.productDetail.price
                                                    .currency.symbol
                                            }
                                            {this.state.productDetail.price.max}
                                        </p>
                                    </Form.Group>
                                </Row>
                            )}

                            <Row>
                                <Form.Group as={Col}>
                                    <Form.Label>Quantity</Form.Label>
                                    <select
                                        className="form-control"
                                        style={{ width: '100%' }}
                                        name="quantity"
                                        onChange={this.handleChangeQuantity}
                                        value={this.state.quantity}
                                    >
                                        {this.state.qtyOptions.map((qty) => (
                                            <option key={qty} value={qty}>
                                                {qty}
                                            </option>
                                        ))}
                                    </select>
                                </Form.Group>
                            </Row>
                            <Row>
                                <Form.Group as={Col}>
                                    <Form.Label>Comment</Form.Label>
                                    <Form.Control
                                        placeholder="Enter comment"
                                        type="text"
                                        name="comment"
                                        value={this.state.comment}
                                        onChange={this.onChangeValues}
                                    />
                                </Form.Group>
                            </Row>

                            <Row>
                                <Form.Group as={Col}>
                                    {!this.state.btnClicked && (
                                        <Button
                                            variant="primary"
                                            type="submit"
                                            onClick={this.confirmSubmit}
                                        >
                                            Submit
                                        </Button>
                                    )}
                                </Form.Group>
                            </Row>
                        </Col>

                        <Col xs={12}>
                            <Tabs
                                defaultActiveKey="description"
                                id="uncontrolled-tab-example"
                            >
                                <Tab eventKey="description" title="DESCRIPTION">
                                    <p
                                        style={{ marginTop: '1rem' }}
                                        dangerouslySetInnerHTML={{
                                            __html: this.state.productDetail
                                                .description
                                        }}
                                    ></p>
                                </Tab>
                                <Tab eventKey="t&n" title="TERMS & CONDITIONS">
                                    <p
                                        style={{ marginTop: '1rem' }}
                                        dangerouslySetInnerHTML={{
                                            __html: this.state.productDetail
                                                .tnc_content
                                        }}
                                    ></p>
                                </Tab>
                                {this.state.productDetail.redeem &&
                                    this.state.productDetail.redeem != '' && (
                                        <Tab
                                            eventKey="reedem"
                                            title="HOW TO REDEEM"
                                        >
                                            <p
                                                style={{ marginTop: '1rem' }}
                                                dangerouslySetInnerHTML={{
                                                    __html: this.state
                                                        .productDetail.redeem
                                                }}
                                            ></p>
                                        </Tab>
                                    )}
                            </Tabs>
                        </Col>
                    </Row>
                )}

                <Modal
                    show={this.state.modalShow}
                    onHide={this.handleClose}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Please confirm</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>
                            Are you sure you want to purchase{' '}
                            {this.state.quantity} x{' '}
                            {parseFloat(this.state.denomination).toFixed(2)} Rs
                            gift cards with total value of{' '}
                            {parseFloat(
                                this.state.denomination * this.state.quantity -
                                    (this.state.denomination *
                                        this.state.quantity *
                                        this.state.discount) /
                                        100
                            ).toFixed(2)}{' '}
                            Rs{' '}
                            {this.state.discount > 0 && (
                                <span>
                                    (after {this.state.discount}% discount)
                                </span>
                            )}
                            ?
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={this.getGiftCard}>
                            Confirm
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Container>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(GCPurchase);
